import { render, staticRenderFns } from "./InformationRequest.vue?vue&type=template&id=407bc97d&"
import script from "./InformationRequest.vue?vue&type=script&lang=js&"
export * from "./InformationRequest.vue?vue&type=script&lang=js&"
import style0 from "./InformationRequest.vue?vue&type=style&index=0&id=407bc97d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports